<template>
    <div class="backgrounds">
        <section class="top-bar"> 
            <TopBar :imagem="item.imagem" :titulo="item.nome" :descricao="item.descricao"/>
        </section>

        <EtapasCounter :indexCorrente="etapaIndex" :quantidadeTotal="this.qtdEtapas" />
        <div  :class="etapaClassName">
            <cada-etapa 
                :indexEtapaCorrente="etapaIndex"
                :totalEtapas="item.etapas.length" 
                :isTipoComboPizza="false"
                :etapa="item.etapas[etapaIndex]"
                :cobrarPorEtapa="item.comboEtapaPrecoPorEtapaOuItem"
                :atributoAnteriorCasoItemEditado="this.atributosAnteriores(etapaIndex)"
                @onSelectedItems="onSeletectedItemsNaEtapa"
            /> 
        </div>
    </div>
</template>

<script> 

import EtapasCounter from '@/components/Base/EtapasCounter.vue';
import TopBar from '../TopBar.vue';
import CadaEtapa from './CadaEtapa.vue';

/**
 * Quando o item é do tipo mercadoria. Depois de adicionar o item, retora para a pagina anterior
 * @vue-prop {Object} item é o item especifico escolhido
 * @vue-data {Number} [quantidade = 1] quantidade de mercadorias, sendo que inicia com 1
 * @vue-data {Number} [precoTotal=this.item.preco] é preco da mercadoria
 * @vue-computed {Boolean} [esconderPrecoUnitario] manda como prop para o componente BottomBar se ele deve esconder o preco unitario ou nao. Ele sempre deve
 * esconder caso a quantidade de itens selecionados eja igual a 1, valido apenas para mercadorias; 
 */
export default { 
  
    nome: "TipoComboPorEtapa",
 
    props: {
        item: Object,
        atributoAnteriorCasoItemEditado: Object,
    },
    
    data() {
        return { 
            etapaIndex: this.atributoAnteriorCasoItemEditado ? this.atributoAnteriorCasoItemEditado.indexDaEtapa : 0,
            etapaClassName: "etapa",

            /** 
             * Esta var eh um array de arrays. Cada etapa vai voltar um array de itens 
             * ja que cada etapa pode ter um ou mais itnes escolhidos
             */
            todosItensFinalizados: [],
        }
    }, 

    computed: {
        qtdEtapas() {
            return this.item.etapas.length
        },

        valorFinalComputed() {
            let soma = 0.0
            for (var i = 0; i < this.todosItensFinalizados.length; i++) {
                for (var ii = 0; ii < this.todosItensFinalizados[i].length; ii++) {
                    const item = this.todosItensFinalizados[i][ii]

                    console.log("aqui esta a soma")
                    console.log(item)

                    // se for um item fracionado
                    if (item.fracaoQuantidade) {
                        soma += item.precoTotal * 1/ item.fracaoQuantidade
                    }

                    // se for produto, o valor vem na chave [precoTotal] ja com os adicionais
                    else if (item.tipo == "produto") {
                        if (isNaN(item.precoTotal)) {
                            item.precoTotal  = 0.0
                        }
                        if (isNaN(item.preco)) {
                            item.preco  = 0.0
                        }
                        soma += item.precoTotal 
                    }
                    
                    // se for combo por etapa, temos o valor de cada item da etapa na chave [item.valorVendaItem]
                    // pois o usuario pode colocar um valor especial para cada item apenas dentro do combo
                    else if (item.item != null && item.item.valorVendaItem != null && item.item.valorVendaItem != "") {
                        soma += item.item.valorVendaItem
                    } 

             
                    
                    else {
                        soma += item.precoTotal
                    }
                    
                }
            }
    
            return soma;
        }
      
    },

    created() {
        // this.scrollToTop();
        
//80400428     10 por 30
//80400418     10 por 25
    },

    updated() {
    },

    watch: {
        etapaIndex() {
            this.etapaClassName = "etapa-sair"
            setTimeout(() => {
                this.etapaClassName = "etapa"
            }, 500);

        }
    },

    methods: {
        atributosAnteriores(indexDaEtapa) {
            const etapaNumero = Number(indexDaEtapa);
            const subitensOriginais = this.atributoAnteriorCasoItemEditado?.subitens;
            const todosOsSubitens = Array.isArray(subitensOriginais) ? subitensOriginais : [];

            const subitensFiltrados = todosOsSubitens.filter((subitem) => Number(subitem?.indexDaEtapa) === etapaNumero)
            subitensFiltrados.map(e=> console.log(e))
            return subitensFiltrados;
        },

        onSeletectedItemsNaEtapa(item) {
            //Se o item eh editado , so editamos a etapa selecionada.
            if(this.atributoAnteriorCasoItemEditado){
                //aqui pegamos os novos itens escolhidos e colocamos o index da etapa editada
                item.map(e=> {e.indexDaEtapa = this.atributoAnteriorCasoItemEditado.indexDaEtapa})
                // Reconstrói os subitens mantendo a ordem: substitui os da etapa editada pelos novos
                const subitensAtualizados = [];
                this.atributoAnteriorCasoItemEditado.subitens.forEach(subitem => {
                    if (subitem.indexDaEtapa !== this.atributoAnteriorCasoItemEditado.indexDaEtapa) {
                        subitensAtualizados.push(subitem);
                    }
                });
                // Encontra a posição onde inserir os novos itens
                let posicaoInsercao = 0;
                for (let i = 0; i < this.atributoAnteriorCasoItemEditado.subitens.length; i++) {
                    if (this.atributoAnteriorCasoItemEditado.subitens[i].indexDaEtapa === this.atributoAnteriorCasoItemEditado.indexDaEtapa) {
                        posicaoInsercao = i;
                        break;
                    }
                }
                subitensAtualizados.splice(posicaoInsercao, 0, ...item);
                // Reconstrói o array de arrays por etapa
                this.todosItensFinalizados = [];
                for (let etapaIdx = 0; etapaIdx < this.item.etapas.length; etapaIdx++) {
                    this.todosItensFinalizados[etapaIdx] = subitensAtualizados.filter(s => s.indexDaEtapa === etapaIdx);
                }
                this.enviarCarrinho()
            }
            else{
                this.todosItensFinalizados.push(item)
                if (this.etapaIndex < this.qtdEtapas - 1) {
                    this.etapaIndex = this.etapaIndex + 1
                } else {
                    this.enviarCarrinho()
                }
            }
        },





        /**
         * Aqui vamos desmontar a var @see this.todosItensFinalizados. Esta var eh um array de arrays.
         * Vamos colocar tudo em um array so
         */
        arrumarArrayDeItensFinalizados() {
            let arrayFinal = [] 
            for (var i = 0; i < this.todosItensFinalizados.length; i++) {

                let indexDaEtapaContador = 0
                let fracaoContador = 1
                for (var ii = 0; ii < this.todosItensFinalizados[i].length; ii++) {
                    const item = this.todosItensFinalizados[i][ii]

                    item.quantidade = 1

                    /** checamos se estamos na mesma etapa, paa resetar oiu nao as vars [indexDaEtapa] e [fracaoContador] */
                    if (item.indexDaEtapa != indexDaEtapaContador) {
                        indexDaEtapaContador = item.indexDaEtapa
                        fracaoContador= 1
                    }

                    /** aqui vamos arrumar o atributo @quantidade caso sera um item fracionado */
                    if (item.fracaoQuantidade) {
                        if (this.todosItensFinalizados[i].length - 1 == ii) {
                            item.quantidade = Number(fracaoContador.toFixed(3))
                        } else {
                            item.quantidade = Number((1 / Number(item.fracaoQuantidade)).toFixed(3))
                            fracaoContador = Number((fracaoContador -  (1 / item.fracaoQuantidade)).toFixed(3))
                        }
                    }

                    if(!this.atributoAnteriorCasoItemEditado){
                        item.indexDaEtapa = i
                    }
                    arrayFinal.push(item)
                }
                
            }
            return arrayFinal
        },



        /**
         * é o metodo que envia a mercadoria para o carrinho envia em fomato de objeto o id, o nome, o preco unitario, a quantidade escolhida
         * e o preco total final do item. Depois de adicionar o item, retora para a pagina anterior
         */
        enviarCarrinho() {
            let itemFinalizado = {
                tipo: "comboPorEtapa",
                id: this.item.id,
                nome: this.item.nome,
                preco: this.valorFinalComputed,
                tempoEstimado: this.item.tempoEstimado,
                valorUnitarioPagoNoSmartPos: this.valorFinalComputed,
                quantidade: 1,
                precoTotal: this.valorFinalComputed,
                subitens: this.arrumarArrayDeItensFinalizados()
                ///
            }
            this.$store.dispatch('setItensCarrinho', itemFinalizado)
            this.$router.back()
        }

    },
    components: {
    TopBar,
    CadaEtapa,
    EtapasCounter,
}

}
</script>

<style scoped>

.etapa {
    animation: mudar-etapa 0.5s forwards;
}
@keyframes mudar-etapa {
    from { transform: translateX(50%); opacity: 0;}
    to { transform: translateX(0%); opacity: 1;}
}
.etapa-sair {
    animation: mudar-etapa-sair 0.5s forwards;
}
@keyframes mudar-etapa-sair {
    from { transform: translateX(0%); opacity: 1;}
    to { transform: translateX(-50%); opacity: 0;}
}


.item-row {
    color: black; background: white; display: flex;  text-align: start; padding-block: 15px; padding-inline: 15px;
}
.item-row-sair-fora {
    pointer-events: none;
    position: relative;
    animation: item-sair-fora-anim 0.5s forwards, item-sair-fora-anim2 0.1s forwards 0.5s;

}

@keyframes item-sair-fora-anim {
    from {left: 0}
    to {left: -110%}
}

@keyframes item-sair-fora-anim2 {
    /* from {display: flex} */
    to {display: none}
}

.backgrounds {
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
}

.top-bar {
    margin: 0;
}
.bodys{
    /* overflow-y: auto; */
    flex-grow: 1;
}

.icon {
    filter: invert(100%);
    width: 25px;
    height: 25px;
    margin-right: 15px;
    margin-block: auto;
}

#quantidadeTitulo {
    margin: 0;
    padding: 10px;
    font-size: 14px;
    color: white;
}

#mercadoriaImg {
    width: 100%;
    height: 180px;
    object-fit: cover;
}


#nomeDaMercadoria {
    width: 100%;
    background: black;
    color: white;
    font-size: 18px;
    padding: 10px;
    margin: 0;
}

.btnMaisOuMenos {
    border-radius: 5px;
    background: var(--primaryDark_azul);
    color: white;
    font-weight: 800;
    font-size: 25px;
    padding: 3px;
    width: 40px;
}

#quantidadeEscolhida {
    font-weight: 800;
    margin: 10px;
    font-size: 25px;
    color: white;
}


.btn-avancar-bottom-observacao {
    width: calc(100% - 20px);
    position: relative;
    bottom: 0;
    left: 0;
    /* height: 75px; */
    background: white;
    padding: 6px;
}


</style>